import api from '@/apis'

export const fetchMessages = ({ orderId, ...params }) =>
  api.get(`/orders/${orderId}/messages`, { params })

export const sendMessage = ({ order_id, ...data}) => {
  api.post(`/orders/${order_id}/messages`, data)
}
